import React from 'react';
import { FormGroup, FormInput, ModalBody } from 'shards-react';
import SelectOptionsType from '../../common/SelectOptionsType';
import SelectOrganizations from '../../common/SelectOrganizations';
import SelectRole from '../../common/SelectRole';
import SelectNotification from '../../common/SelectNotification';
import { EDIT_ACTION } from '../../../constants';
import type { Language, Role, SelectOption } from '../../../types/common';
import type { OrganizationType } from '../../../types/organization';
import type { OrganizationUserType } from '../../../types/user';
import type { OptionsType } from '../../../types/options';

interface ModalEditBodyProps {
  dialogMode: string;
  warningText: string;

  selectId: string;
  selectClass: string;
  isMulti: boolean;
  tradingCompany: OptionsType[];
  optionsTradingCompany: OptionsType[];
  placeholder: string;
  language: Language;
  onChangeSelect: (option: OptionsType[]) => void;

  labelOrg: string;
  disabledOrg: boolean;
  optionsOrg: OrganizationType[];
  selectedOrg: OrganizationType[];
  onChangeOrg: (options: OrganizationType[]) => void;

  labelName: string;
  name: string;
  disabledName: boolean;
  onChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;

  labelEmail: string;
  email: string;
  disabledEmail: boolean;
  onChangeEmail: (event: React.ChangeEvent<HTMLInputElement>) => void;

  labelRole: string;
  disabledRole: boolean;
  selectedRole: Role[];
  onChangeRole: (options: Role[] | null) => void;

  labelNotification: string;
  disabledNotification: boolean;
  organizationUsers: OrganizationUserType[];
  onChangeNotification: (organizationUser: OrganizationUserType) => void;
}

const ModalEditBody = ({
  dialogMode,
  warningText,

  selectId,
  selectClass,
  isMulti,
  tradingCompany,
  optionsTradingCompany,
  placeholder,
  language,
  onChangeSelect,

  labelOrg,
  disabledOrg,
  optionsOrg,
  selectedOrg,
  onChangeOrg,

  labelName,
  name,
  disabledName,
  onChangeName,

  labelEmail,
  email,
  disabledEmail,
  onChangeEmail,

  labelRole,
  disabledRole,
  selectedRole,
  onChangeRole,

  labelNotification,
  disabledNotification,
  organizationUsers,
  onChangeNotification,
}: ModalEditBodyProps): React.ReactElement => {
  // console.log(selectedOrg);
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <FormGroup>
        {/* {organizationUsers} */}
        {dialogMode !== EDIT_ACTION.VIEW && (
          <SelectOptionsType
            id={selectId}
            className={selectClass}
            isMulti={isMulti}
            value={tradingCompany}
            options={optionsTradingCompany}
            placeholder={placeholder}
            language={language}
            onChange={onChangeSelect}
          />
        )}

        {/* 組織の選択（ただし豊田通商ユーザは変更できない）
        ---------------------------------------- */}
        <label htmlFor="selectOrganization">
          {labelOrg}
          {/* 豊田通商ユーザは組織を変更できない旨の注意書き */}
          {dialogMode === EDIT_ACTION.UPDATE && <small className="ml-2">{warningText}</small>}
        </label>
        <SelectOrganizations className="mb-3" disabled={disabledOrg} options={optionsOrg} selected={selectedOrg} onChange={onChangeOrg} />

        {/* ユーザ名
        ---------------------------------------- */}
        <label htmlFor="name">{labelName}</label>
        <FormInput id="name" className="mb-3" value={name} disabled={disabledName} onChange={onChangeName} />

        {/* メールアドレス
        ---------------------------------------- */}
        <label htmlFor="email">{labelEmail}</label>
        <FormInput id="email" className="mb-3" value={email} disabled={disabledEmail} onChange={onChangeEmail} />

        {/* ロール
        ---------------------------------------- */}
        <label htmlFor="selectRole">{labelRole}</label>
        <SelectRole className="mb-3" disabled={disabledRole} selected={selectedRole} selectedOrganization={selectedOrg} onChange={onChangeRole} />

        {/* メール通知
        ---------------------------------------- */}
        <label>{labelNotification}</label>
        {organizationUsers.length > 0 &&
          organizationUsers.map((orgUser) => {
            return <SelectNotification key={'select-notification-' + String(orgUser.organizationId)} disabled={disabledNotification} organizationUser={orgUser} onChange={onChangeNotification} />;
          })}
      </FormGroup>
    </ModalBody>
  );
};

export default ModalEditBody;
